/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { _ as _classCallCheck, a as _createClass } from '../../../_chunks/dep-6d195cc7.mjs';
import { _ as _defineProperty } from '../../../_chunks/dep-a26b9c60.mjs';
import { i as isUndefined_1 } from '../../../_chunks/dep-ce88e3c0.mjs';
import { i as isBoolean_1 } from '../../../_chunks/dep-11ebe61f.mjs';
import { o as omit_1 } from '../../../_chunks/dep-7cc8d2c3.mjs';
import { g as get_1 } from '../../../_chunks/dep-87c358ba.mjs';
import log from '../log/log.mjs';
import '../../../_chunks/dep-b333ab93.mjs';
import '../../../_chunks/dep-6f3e4f56.mjs';
import '../../../_chunks/dep-b1060562.mjs';
import '../../../_chunks/dep-8049d2e0.mjs';
import '../../../_chunks/dep-7ad89920.mjs';
import '../../../_chunks/dep-0d1bd08c.mjs';
import '../../../_chunks/dep-c5d88cfe.mjs';
import '../../../_chunks/dep-36563716.mjs';
import '../../../_chunks/dep-b56b2dc0.mjs';
import '../../../_chunks/dep-77f634fb.mjs';
import '../../../_chunks/dep-28ae3cda.mjs';
import '../../../_chunks/dep-e50fa7b0.mjs';
import '../../../_chunks/dep-97c71289.mjs';
import '../../../_chunks/dep-4efc69ee.mjs';
import '../../../_chunks/dep-ae08d6c4.mjs';
import '../../../_chunks/dep-7211604f.mjs';
import '../../../_chunks/dep-75df64b1.mjs';
import '../../../_chunks/dep-48b9a098.mjs';
import '../../../_chunks/dep-c7e4942d.mjs';
import '../../../_chunks/dep-25d66c95.mjs';
import '../../../_chunks/dep-372265bb.mjs';
import '../../../_chunks/dep-d940e2da.mjs';
import '../../../_chunks/dep-52c1d6a9.mjs';
import '../../../_chunks/dep-18bb982b.mjs';
import '../../../_chunks/dep-c57d8117.mjs';
import '../../../_chunks/dep-6043e9fc.mjs';
import '../../../_chunks/dep-6e04bcaa.mjs';
import '../../../_chunks/dep-d23f3733.mjs';
import '../../../_chunks/dep-91fc304f.mjs';
import '../../../_chunks/dep-881cffb7.mjs';
import '../../../_chunks/dep-4b3e18ca.mjs';
import '../../../_chunks/dep-b6b4eaa3.mjs';

var nodeKey = "__tdesign_tree-node__";
var TreeNodeModel = /*#__PURE__*/function () {
  function TreeNodeModel(node) {
    _classCallCheck(this, TreeNodeModel);
    _defineProperty(this, nodeKey, void 0);
    this[nodeKey] = node;
  }
  _createClass(TreeNodeModel, [{
    key: "value",
    get: function get() {
      var node = this[nodeKey];
      return node.value;
    }
  }, {
    key: "label",
    get: function get() {
      var node = this[nodeKey];
      return node.label;
    }
  }, {
    key: "data",
    get: function get() {
      var node = this[nodeKey];
      return node.data;
    }
  }, {
    key: "actived",
    get: function get() {
      var node = this[nodeKey];
      return node.actived;
    }
  }, {
    key: "expanded",
    get: function get() {
      var node = this[nodeKey];
      return node.expanded;
    }
  }, {
    key: "checked",
    get: function get() {
      var node = this[nodeKey];
      return node.checked;
    }
  }, {
    key: "indeterminate",
    get: function get() {
      var node = this[nodeKey];
      return node.indeterminate;
    }
  }, {
    key: "loading",
    get: function get() {
      var node = this[nodeKey];
      return node.loading;
    }
  }, {
    key: "disabled",
    get: function get() {
      var node = this[nodeKey];
      return node.isDisabled();
    }
  }, {
    key: "getLevel",
    value: function getLevel() {
      var node = this[nodeKey];
      return node.getLevel();
    }
  }, {
    key: "getIndex",
    value: function getIndex() {
      var node = this[nodeKey];
      return node.getIndex();
    }
  }, {
    key: "isFirst",
    value: function isFirst() {
      var node = this[nodeKey];
      return node.isFirst();
    }
  }, {
    key: "isLast",
    value: function isLast() {
      var node = this[nodeKey];
      return node.isLast();
    }
  }, {
    key: "isLeaf",
    value: function isLeaf() {
      var node = this[nodeKey];
      return node.isLeaf();
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(newData) {
      var node = this[nodeKey];
      return node.insertBefore(newData);
    }
  }, {
    key: "insertAfter",
    value: function insertAfter(newData) {
      var node = this[nodeKey];
      return node.insertAfter(newData);
    }
  }, {
    key: "appendData",
    value: function appendData(data) {
      var node = this[nodeKey];
      return node.append(data);
    }
  }, {
    key: "getPath",
    value: function getPath() {
      var node = this[nodeKey];
      var nodes = node.getPath();
      return nodes.map(function (item) {
        return item.getModel();
      });
    }
  }, {
    key: "getParent",
    value: function getParent() {
      var _node$parent;
      var node = this[nodeKey];
      return (_node$parent = node.parent) === null || _node$parent === void 0 ? void 0 : _node$parent.getModel();
    }
  }, {
    key: "getParents",
    value: function getParents() {
      var node = this[nodeKey];
      var nodes = node.getParents();
      return nodes.map(function (item) {
        return item.getModel();
      });
    }
  }, {
    key: "getRoot",
    value: function getRoot() {
      var node = this[nodeKey];
      var root = node.getRoot();
      return root === null || root === void 0 ? void 0 : root.getModel();
    }
  }, {
    key: "getSiblings",
    value: function getSiblings() {
      var node = this[nodeKey];
      var nodes = node.getSiblings();
      return nodes.map(function (item) {
        return item.getModel();
      });
    }
  }, {
    key: "getChildren",
    value: function getChildren(deep) {
      var node = this[nodeKey];
      var childrenModel = false;
      var children = node.children;
      if (Array.isArray(children)) {
        if (children.length > 0) {
          if (deep) {
            var nodes = node.walk();
            nodes.shift();
            childrenModel = nodes.map(function (item) {
              return item.getModel();
            });
          } else {
            childrenModel = children.map(function (item) {
              return item.getModel();
            });
          }
        } else {
          childrenModel = false;
        }
      } else if (isBoolean_1(children)) {
        childrenModel = children;
      }
      return childrenModel;
    }
  }, {
    key: "remove",
    value: function remove(value) {
      var node = this[nodeKey];
      if (!value) {
        node.remove();
        return;
      }
      var tree = node.tree;
      var targetNode = tree.getNode(value);
      if (!targetNode) {
        log.warnOnce("Tree", "`".concat(value, "` is not exist"));
        return;
      }
      var parents = targetNode.getParents();
      var parentValues = parents.map(function (pnode) {
        return pnode.value;
      });
      if (parentValues.indexOf(node.value) < 0) {
        log.warnOnce("Tree", "`".concat(value, "` is not a childNode of current node"));
        return;
      }
      targetNode.remove();
    }
  }, {
    key: "setData",
    value: function setData(data) {
      var node = this[nodeKey];
      var syncAttrs = ["value", "label", "disabled"];
      var cleanData = omit_1(data, ["children"].concat(syncAttrs));
      var keys = node.tree.config.keys;
      syncAttrs.forEach(function (attr) {
        var dataAttrValue = get_1(data, (keys === null || keys === void 0 ? void 0 : keys[attr]) || attr);
        if (!isUndefined_1(dataAttrValue)) cleanData[attr] = dataAttrValue;
      });
      Object.assign(node.data, cleanData);
      Object.assign(node, cleanData);
      node.update();
    }
  }]);
  return TreeNodeModel;
}();
function createNodeModel(node) {
  var model = new TreeNodeModel(node);
  return model;
}

export { TreeNodeModel, createNodeModel, nodeKey };
//# sourceMappingURL=tree-node-model.mjs.map
